// extracted by mini-css-extract-plugin
export var container = "landing-page-module--container--8745f";
export var image = "landing-page-module--image--056c8";